import DEFAULT_THEME from 'tailwindcss/defaultTheme';

/** Single source of truth for Tailwind's named breakpoints. Imported by
 * `tailwind.config.ts` (so the CSS-side `lg:`/`max-lg:` modifiers honour these
 * values) and by `useIsTailwindBreakpoint()` (so JS-side viewport queries
 * agree). Add custom screens here, not in either consumer. */
export const SCREENS = {
    ...DEFAULT_THEME.screens,
    xs: '512px',
} as const;

export type TailwindBreakpoint = keyof typeof SCREENS;
